var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "loading" }, [
    _c(
      "svg",
      {
        staticStyle: {
          margin: "auto",
          background: "none",
          display: "block",
          "shape-rendering": "auto"
        },
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          width: "200px",
          height: "200px",
          viewBox: "0 0 100 100",
          preserveAspectRatio: "xMidYMid"
        }
      },
      [
        _c(
          "circle",
          {
            attrs: {
              cx: "50",
              cy: "50",
              fill: "none",
              stroke: "#633dd1",
              "stroke-width": "10",
              r: "35",
              "stroke-dasharray": "164.93361431346415 56.97787143782138"
            }
          },
          [
            _c("animateTransform", {
              attrs: {
                attributeName: "transform",
                type: "rotate",
                repeatCount: "indefinite",
                dur: "1s",
                values: "0 50 50;360 50 50",
                keyTimes: "0;1"
              }
            })
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }